import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=8a2b1df4&"
import script from "./CheckboxGroup.vue?vue&type=script&setup=true&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports